import { ReactNode } from "react";
import { SystemConfigurationTab } from "../api/it/account-category/account-category-api-state";
import { SuffixOption } from "../api/it/account/account-api-state";
import { DEPARTMENT_CODES, USER_ROLES_CODES } from "../constant/department-code-constant";
import { NAV_MENU_ID } from "../constant/system";
import { CategoryInfo } from "../types/type";

interface SubMenuItem {
    id: number;
    label: string;
    path: string;
}

export interface NavItem {
    id: number;
    label: string;
    icon: ReactNode;
    path?: string;
    subMenu?: SubMenuItem[];
    allowedRoles: string[]
    allowedPositions?: string[]
}

export const navItems: NavItem[] = [
    {
        id: NAV_MENU_ID.CREATE_PROPOSAL,
        label: "Create Proposal",
        icon: "📝",
        path: "create-proposal",
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS],
    },
    {
        id: NAV_MENU_ID.PROPOSAL_STATUS,
        label: "Proposal Status",
        icon: "📋",
        path: "status-proposal",
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
    },
    {
        id: NAV_MENU_ID.CREATE_RENEWAL,
        label: "Renewal",
        icon: "📋",
        path: "renewal",
        allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.departmentHead.name, USER_ROLES_CODES.MONITORING_GMS.name],
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
    },
    // {
    //     id: NAV_MENU_ID.PROPOSALS,
    //     label: "Proposals",
    //     icon: "📋",
    //     path: "proposals",
    //     allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.departmentHead.name, USER_ROLES_CODES.MONITORING_GMS.name],
    //     allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
    // },
    {
        id: NAV_MENU_ID.EXISTING_GROUP_REQ,
        label: "Request Existing Group",
        icon: "⏳",
        path: "existing-group-requests",
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
        allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.MONITORING_GMS.name]
    },
    {
        id: NAV_MENU_ID.PROPOSAL_REQ_EXTENSION,
        label: "Request Extension",
        icon: "⏳",
        path: "request-extension-proposal",
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
        allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.MONITORING_GMS.name]
        // allowedPositions: [USER_ROLES_CODES.TL, USER_ROLES_CODES.SA]
    },
    {
        id: NAV_MENU_ID.TRANSFER_OWN,
        label: "Transfer ownership",
        icon: "⏳",
        path: "transfer-ownership-proposal",
        allowedRoles: [DEPARTMENT_CODES.MKT_GMS, DEPARTMENT_CODES.MONITORING_DEPT_GMS],
        allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.MONITORING_GMS.name]
    },
    // {
    //     id: NAV_MENU_ID.GENERAL_CHAT,
    //     label: "General Chat",
    //     icon: "⏳",
    //     path: "chats",
    //     allowedRoles: [DEPARTMENT_CODES.MKT_GMS],
    //     // allowedPositions: [USER_ROLES_CODES.TL]
    //     // allowedPositions: [USER_ROLES_CODES.TL, USER_ROLES_CODES.SA]
    // },
    // {
    //     id: NAV_MENU_ID.TRANSFER_OWN,
    //     label: "My Team",
    //     icon: "⏳",
    //     path: "my-team",
    //     allowedRoles: [DEPARTMENT_CODES.MKT_GMS],
    //     allowedPositions: [USER_ROLES_CODES.TL, USER_ROLES_CODES.SA]
    // },
    {
        id: NAV_MENU_ID.BOOKED_PROPOSAL,
        label: "Policy Creation",
        icon: "⏳",
        path: "policy-creation",
        allowedRoles: [DEPARTMENT_CODES.EBAM],
    },
    {
        id: NAV_MENU_ID.COC_COMPLIANCE,
        label: "COC Generation",
        icon: "⏳",
        path: "coc-generation",
        allowedRoles: [DEPARTMENT_CODES.EBAM],
    },
    // {
    //     id: NAV_MENU_ID.POLICY_REVIEW,
    //     label: "Policy Review",
    //     icon: "⏳",
    //     path: "policy-review",
    //     allowedRoles: [DEPARTMENT_CODES.EBAM],
    // },
    {
        id: NAV_MENU_ID.PROPOSAL_COMPUTATION,
        label: "Proposal Computation",
        icon: "🧮",
        path: "computation-proposal",
        // allowedRoles: [DEPARTMENT_CODES.ACTUARIAL, DEPARTMENT_CODES.MKT_GMS]
        allowedRoles: [DEPARTMENT_CODES.ACTUARIAL],
    },
    {
        id: NAV_MENU_ID.APPROVAL_MY,
        label: "For Approval Request", // for specific user 
        icon: "🧮",
        path: "my-approval-requests",
        allowedRoles: [DEPARTMENT_CODES.ACTUARIAL],
    },
    {
        id: NAV_MENU_ID.APPROVAL_TEAM,
        label: "All Approval Requests", // for admin
        icon: "🧮",
        path: "approval-requests",
        allowedRoles: [DEPARTMENT_CODES.ACTUARIAL],
        allowedPositions: [USER_ROLES_CODES.TL.name, USER_ROLES_CODES.superAdmin.name]
    },
    {
        id: NAV_MENU_ID.REQUEST_AMENDMENT,
        label: "Request Amendments",
        icon: "📝",
        path: "request-amend",
        // allowedRoles: [DEPARTMENT_CODES.ACTUARIAL, DEPARTMENT_CODES.MKT_GMS]
        allowedRoles: [DEPARTMENT_CODES.ACTUARIAL],
    },
    {
        id: NAV_MENU_ID.NEW_ACCOUNT,
        label: "New Account",
        icon: "🆕",
        path: "new-user",
        allowedRoles: [DEPARTMENT_CODES.IT],
    },
    {
        id: NAV_MENU_ID.USER_MANAGEMENT,
        label: "User Management",
        icon: "👥",
        path: "user-management",
        allowedRoles: [DEPARTMENT_CODES.IT],
    },
    {
        id: NAV_MENU_ID.CATEGORY_MANAGEMENT,
        label: "System Configuration",
        icon: "⚙️",
        path: "system-configuration",
        allowedRoles: [DEPARTMENT_CODES.IT],
    },
    {
        id: NAV_MENU_ID.MY_TEAM,
        label: "My Team",
        icon: "⏳",
        path: "my-team",
        allowedRoles: [
            DEPARTMENT_CODES.MKT_GMS, 
            // DEPARTMENT_CODES.IT, 
            // DEPARTMENT_CODES.SALES_AND_MKT, 
            // DEPARTMENT_CODES.AMS, 
            // DEPARTMENT_CODES.MKT_ASST,
            DEPARTMENT_CODES.ACTUARIAL,
            DEPARTMENT_CODES.EBAM,
            // DEPARTMENT_CODES.MONITORING_DEPT_GMS,
            // DEPARTMENT_CODES.MONITORING_DEPT_ACTUARIAL,
        ],
        // allowedPositions: [USER_ROLES_CODES.TL, USER_ROLES_CODES.SA]
        allowedPositions: [USER_ROLES_CODES.superAdmin.name, USER_ROLES_CODES.TL.name, USER_ROLES_CODES.MONITORING_GMS.name],
    },
    {
        id: NAV_MENU_ID.ACCOUNT_SETTING,
        label: "Account Setting",
        icon: "👤",
        path: "my-account",
        allowedRoles: [
            DEPARTMENT_CODES.MKT_GMS, 
            DEPARTMENT_CODES.IT, 
            DEPARTMENT_CODES.SALES_AND_MKT, 
            DEPARTMENT_CODES.AMS, 
            DEPARTMENT_CODES.MKT_ASST,
            DEPARTMENT_CODES.ACTUARIAL,
            DEPARTMENT_CODES.EBAM,
            DEPARTMENT_CODES.MONITORING_DEPT_GMS,
            DEPARTMENT_CODES.MONITORING_DEPT_ACTUARIAL,
        ],
    },
];

export const suffix: SuffixOption[] = [
    { id: 2, name: "Jr."},
    { id: 3, name: "Sr."},
    { id: 4, name: "I"},
    { id: 5, name: "II"},
    { id: 6, name: "III"},
    { id: 7, name: "IV"},
    { id: 8, name: "V"},
]

export const systemConfiguration: SystemConfigurationTab[] = [
    { id: 1, value: 'roles', name: "Roles"},
    { id: 2, value: 'departments', name: "Departments"},
    { id: 3, value: 'locations', name: "Locations"},
]

export const statusOptions = [
    {
        id: 1,
        label: "Active",
        value: true,
        activeClass: "border-[#186cb2] bg-[#186cb2]/10",
        inactiveClass: "border-gray-300 hover:border-[#186cb2]",
    },
    {
        id: 2,
        label: "Inactive",
        value: false,
        activeClass: "border-red-500 bg-red-50 text-red-600",
        inactiveClass: "border-gray-300 hover:border-red-500",
    },
];

export const categoryInfo: CategoryInfo = {
        roles: {
            value: "roles",
            title: "Roles",
            subtitle: "Manage user roles and their access levels across the system.",
            button: "Create Role",
        },
        departments: {
            value: "departments",
            title: "Departments",
            subtitle: "Organize users into departments for easier management.",
            button: "Create Department",
        },
        locations: {
            value: "locations",
            title: "Locations",
            subtitle: "Manage office locations and assign users accordingly.",
            button: "Create Location",
        },
    };